module.exports = "/next-static/_next/static/images/hero_image_large-459e80378cd9d919369247892e1ec221.webp";